import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, PlayCircle } from 'lucide-react';
import { BookCallButton } from './BookCallButton';
import { proofPoints, TRAILER_EMBED_URL } from '../../data/foundingProgram';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/7Y6dgrsg2zL5S5gqJcmvvX/Lahore_Fort_and_Hazuri_Bagh.png';
export function FoundingHero() {
  return <section className="relative overflow-hidden border-b border-[#D4AF37]/15" data-id="element-1402" data-mp="dcvju3ugy5mp">
      <img src={HERO_IMAGE} alt="" aria-hidden="true" className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-[0.18]" data-id="element-1403" data-mp="deybesb9s6tj" />
      <div className="pointer-events-none absolute inset-0 bg-[#08070A]/80" aria-hidden="true" data-id="element-1404" data-mp="nbt3asd1f8yu" />

      <div className="relative mx-auto grid w-full max-w-7xl items-center gap-12 px-5 py-20 sm:px-8 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16 lg:py-28" data-id="element-1405" data-mp="s7rz310p3t9a">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-1406" data-mp="2u2ixe8tcn00n">
          <p className="text-[10px] font-medium uppercase tracking-[0.35em] text-[#D4AF37]" data-id="element-1407" data-mp="3rcvs6l90ja3r">
            Founding Members · Sikh Kingdoms
          </p>
          <h1 className="mt-6 font-serif text-4xl leading-[1.02] text-[#FDFBF7] sm:text-6xl lg:text-7xl" data-id="element-1408" data-mp="3mchjd0zl7w4o">
            Canada’s most successful immersive experience is being built right
            now.
            <span className="mt-3 block text-[#D4AF37]" data-id="element-1409" data-mp="iw0y9va7101t">
              We are choosing who builds it with us.
            </span>
          </h1>
          <p className="mt-8 max-w-xl text-lg font-light leading-relaxed text-[#FDFBF7]/70" data-id="element-1410" data-mp="9xxastfndt7d">
            Life in the Sikh Kingdoms opens at Illuminarium Toronto in 2026 — a
            60-minute walk into the Lahore Darbar of Maharaja Ranjit Singh, for
            120 guests a night. Founding Members are the Punjabi executives and
            professionals who put their name on it before the doors open.
          </p>

          <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center" data-id="element-1411" data-mp="312bpk47b6mjn">
            <BookCallButton size="lg" data-id="element-1412" data-mp="2m5cdo45fc7jd" />
            <p className="text-sm font-light leading-relaxed text-[#FDFBF7]/50" data-id="element-1413" data-mp="2m8gmxfxqxtgw">
              25 minutes, direct with{' '}
              <span className="text-[#FDFBF7]/80" data-id="element-1414" data-mp="2dec33gh15iav">Ash Singh</span>.
              <br className="hidden sm:block" data-id="element-1415" data-mp="2dcr51gvibh89" /> No deck, no pressure, no big
              cheque required.
            </p>
          </div>

          <p className="mt-9 flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-[#FDFBF7]/45" data-id="element-1416" data-mp="23g4lcvex2w7t">
            <MapPin className="h-3.5 w-3.5 text-[#D4AF37]" aria-hidden="true" data-id="element-1417" data-mp="28e67xqbjxdo1" />
            Illuminarium Toronto · Distillery District · Premiere season 2026
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-1418" data-mp="1yhb8n57gf98p">
          <div className="border border-[#D4AF37]/30 bg-[#0F0D12] p-2 shadow-[0_30px_90px_rgba(0,0,0,0.55)]" data-id="element-1419" data-mp="1otfnsz486t42">
            <div className="relative aspect-video w-full overflow-hidden bg-black" data-id="element-1420" data-mp="1jtb8hcf204ff">
              <iframe src={TRAILER_EMBED_URL} title="Life in the Sikh Kingdoms — official trailer" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen loading="lazy" className="absolute inset-0 h-full w-full" data-id="element-1421" data-mp="1yqk2kdvqrmau" />
            </div>
            <p className="flex items-center gap-2 px-3 py-3 text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]/80" data-id="element-1422" data-mp="2hh1vojkhkjwq">
              <PlayCircle className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1423" data-mp="2ck33w7oaop1p" />
              Watch the trailer
            </p>
          </div>
        </motion.div>
      </div>

      <div className="relative border-t border-[#D4AF37]/15 bg-[#0B0A0E]/80" data-id="element-1424" data-mp="30ly7m1cdq5vd">
        <dl className="mx-auto grid w-full max-w-7xl grid-cols-2 gap-px px-5 sm:px-8 lg:grid-cols-4" data-id="element-1425" data-mp="35d6heyhmft92">
          {proofPoints.map(point => <div key={point.value} className="py-8 pr-6" data-id="element-1426" data-mp="3aay9ptm6hhds">
              <dt className="font-serif text-4xl text-[#D4AF37] lg:text-5xl" data-id="element-1427" data-mp="2dma5q17arund">
                {point.value}
              </dt>
              <dd className="mt-3 max-w-[15rem] text-sm font-light leading-relaxed text-[#FDFBF7]/55" data-id="element-1428" data-mp="2hmu57bfcfaco">
                {point.label}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}